const StatusColors = {
  active: "success",
  inactive: "info",
  "on-hold": "warning",
  blocked: "error",
}
export default StatusColors